import { render } from "./AdminClientDashboard.vue?vue&type=template&id=5500a74e"
import script from "./AdminClientDashboard.vue?vue&type=script&lang=js"
export * from "./AdminClientDashboard.vue?vue&type=script&lang=js"

import "./AdminClientDashboard.vue?vue&type=style&index=0&id=5500a74e&lang=css"

import exportComponent from "/home/pzborow/works/gunb/rwdzold/dev/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__